
import { getMyCard, addExchange, addAnswer, checkExchange, presentMyCard } from '@/api/chunjie'
import { nowInDateBetwen } from '@/libs/utils'
import Toast from 'vux/src/components/toast/index.vue'
import cookie from 'vux/src/tools/cookie/index.js'
import Countdown from 'vux/src/components/countdown/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { getview } from '@/api/jfhl.js'
import pic1 from '../../assets/chunjie/fokas/pic1.png'
import pic2 from '../../assets/chunjie/fokas/pic2.png'
import pic3 from '../../assets/chunjie/fokas/pic3.png'
import pic4 from '../../assets/chunjie/fokas/pic4.png'
import pic5 from '../../assets/chunjie/fokas/pic5.png'
import pic6 from '../../assets/chunjie/fokas/pic6.png'
import pic7 from '../../assets/chunjie/fokas/pic7.png'
import pic8 from '../../assets/chunjie/fokas/pic8.png'
import pic9 from '../../assets/chunjie/fokas/pic9.png'
import pic10 from '../../assets/chunjie/fokas/pic10.png'
import pic11 from '../../assets/chunjie/fokas/pic11.png'
import pic12 from '../../assets/chunjie/fokas/pic12.png'
export default {
directives: {
TransferDom
},
components: {
XDialog,
Countdown,
Toast
},
name: '',
data () {
return {
ispresent: false,
result: false,
showfokas: false,
viewdata: '',
viewdata2: '',
fokas: '',
fkObj: [],
fokasType: '',

partyid: '1385',
partyid2: '1386',
mobile: this.$store.state.user.personObj.mobile,
randnum: '',
fudai: false,
fudaistatus: 0,
dati: false,
total: 0,
show: false,
showtoast: false,
countdown: {
time: 45,
value: '发送',
start: false
},
exchangeObj: {},
obj: []

}
},
created () {
if (this.$route.query.obj) {

let temp = this.$route.query.obj.slice(0, this.$route.query.obj.length - 1)
this.obj = temp.split(',')

console.log(this.obj)
this.ispresent = true


presentMyCard({
openid: this.obj[1],
cardid: this.obj[0],
hqopenid: this.accountid
}).then(res => {
if (res.status == 'suc') {
this.result = true
}
}).catch((e) => {
this.ispresent = false
this.$router.push({ name: 'page_myfokas' })
})
console.log(this.obj[2])

}
this.view()
},
computed: {
userid () {
return this.$store.state.user.userid
},
accountid () {
return this.$store.state.user.accountid
}
},
methods: {
tip1 () {
this.$vux.toast.text('当前无福卡赠送！', 'middle')
return false
},
tip4 () {
this.$vux.toast.text('活动已结束！', 'middle')
return false
},
tip2 () {
if (this.fudaistatus == -1) {
this.$vux.toast.text('兑换时间已结束', 'middle')
} else {
this.$vux.toast.text('需集齐12张不同的福卡，可兑换福袋！', 'middle')
}
return false
},
tip3 () {
this.$vux.toast.text('猜灯谜开始时间为2021年2月24日！', 'middle')
return false
},
linkindex () {
this.$router.push({ name: 'page_home' })
},
present () {
this.$router.push({ name: 'chunjie_present' })
},
getCard () {
if (!this.showfokas) {
this.showfokas = true
setTimeout(() => {
this.result = false
this.showfokas = false
this.$router.push({ name: 'page_myfokas' })
}, 2000)
}
},

view () {
getview({
id: this.partyid
}).then(res => {
this.viewdata = res.obj
this.view2()
})
},
view2 () {
getview({
id: this.partyid2
}).then(res => {
this.viewdata2 = res.obj
this.getfokas(this.checkExchangeNow)
})
},
getfokas (fn) {
this.fkObj = [
{ pic: pic1, num: 0 },
{ pic: pic2, num: 0 },
{ pic: pic3, num: 0 },
{ pic: pic4, num: 0 },
{ pic: pic5, num: 0 },
{ pic: pic6, num: 0 },
{ pic: pic7, num: 0 },
{ pic: pic8, num: 0 },
{ pic: pic9, num: 0 },
{ pic: pic10, num: 0 },
{ pic: pic11, num: 0 },
{ pic: pic12, num: 0 }
]
this.total = 0
this.fudai = false
getMyCard({
openid: this.accountid,
partyid: this.partyid
}).then(data => {
this.fudaistatus = nowInDateBetwen(



'2021/02/12 00:00:00',
'2021/02/25 23:59:59'
)
this.dati = nowInDateBetwen(

this.viewdata2.signstartdate,
this.viewdata2.signenddate
)
console.log(this.fudaistatus)
data.returnValue.forEach(item => {
this.total++
let n = this.fkObj[item.type - 1].num
this.$set(this.fkObj[item.type - 1], 'num', n + 1)

})


if (this.ispresent) {
this.fokasType = this.fkObj[this.obj[2] - 1].pic
}
for (let i = 0; i < 12; i++) {
if (this.fkObj[i].num === 0) {
if (fn) fn()
return
} else if (i === 11) {
this.fudai = true
}
}
if (fn) fn()
}
)
},

exchange () {
this.$router.push({ name: 'chunjie_getfudai' })
















},
addAnswerNums () {
this.$router.push({ name: 'chunjie_exchange' })
},
checkExchangeNow () {
checkExchange({
openid: this.accountid,
partyid: this.partyid
}).then(data => {
this.exchangeObj = data.returnValue
if (
this.fudaistatus === 1 &&
this.fudai &&
this.exchangeObj.status === 0
) {
this.showtoast = true
} else {
this.showtoast = false
}
})
},
viewmyfokas () {
this.$vux.alert.show({
content: '已兑换福袋：' + this.exchangeObj.lvName
})
}
}
}
